import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Modal } from "antd";
import { X as ICON_X, ArrowRight as ICON_ARROW_RIGHT } from 'react-feather';
import { queries } from "api/api.constants";
import { useLanguage } from "assets/languages";
import GUIDELINE_RULES from "constants/guidelineRules";
import TextArea from "components/textArea";
import Button from "components/button";
import API from "api";

interface Props {
  isVisible: boolean;
  letClose: (result: boolean) => void;
  token: string;
  rentalId: number;
  postingId: number;
  showModal?: any;
}

const BrandFeedbackCreateModal = (props: Props) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.component.postingCard,
  };

  const [feedbackText, setFeedbackText] = useState('');

  const onSubmit = async () => {
    try {
      const response = await API.Rent.storeBrandFeedback({
        brandToken: props.token,
        rentalId: props.rentalId,
        postingId: props.postingId,
        feedbackText: feedbackText,
      });
      props.letClose(true);
    } catch (e) {
      props.showModal({
        hideCloseButton: true,
        text: e.message,
      });
    }
  }

  return (
    <Modal
      wrapClassName="py-4"
      className="rounded-antd-modal"
      centered={true}
      open={props.isVisible}
      onOk={() => props.letClose(false)}
      onCancel={() => props.letClose(false)}
      footer={null}
      closable={false}
      zIndex={1090}
      width={480}
    >
      <div className="relative select-none">
        <div
          className="absolute top-[24px] right-[24px] cursor-pointer"
          onClick={() => props.letClose(false)}
        >
          <ICON_X size={24} />
        </div>
        <div className="py-[50px] flex flex-col bg-white rounded-2xl">
          <div className="flex flex-row justify-between pl-[50px] pr-[30px]">
            <span className="font-bold text-[22px] text-black">
              {languageTexts.brand_feedback_modal_1_title}
            </span>
          </div>
          <div className="mt-[40px] px-[50px] text-[15px] whitespace-pre-wrap leading-5">
            {languageTexts.brand_feedback_modal_1_text}
          </div>
          <div className="mt-[35px] px-[50px]">
            <TextArea
              placeholder={languageTexts.input}
              rows={6}
              bordered
              value={feedbackText ?? ""}
              onChangeText={(value) => {
                console.log('[onChangeText]', value);
                setFeedbackText(value);
              }}
            />
          </div>
          <div className="mt-[18px] px-[50px]">
            <Button
              text={languageTexts.send}
              onClick={() => {
                onSubmit();
              }}
              textColor="WHITE"
              borderColor={"BLACK"}
              buttonColor={"BLACK"}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default BrandFeedbackCreateModal;
